import { useTranslation } from 'react-i18next';
import { useExtensionUtil } from '@/hooks/useExtensionUtil';

interface LearnRulePromptProps {
  host: string;
  sessionName: string;
  sid: string;
  onDismiss: () => void;
}

export function LearnRulePrompt({
  host,
  sessionName,
  sid,
  onDismiss,
}: LearnRulePromptProps) {
  const { t } = useTranslation('common');
  const { sendMessage } = useExtensionUtil();

  const add = () => {
    sendMessage('tabMgm', {
      action: 'addDomainRule',
      sid,
      host,
    });
    onDismiss();
  };

  const snooze = () => {
    sendMessage('tabMgm', {
      action: 'dismissLearnRule',
      host,
    });
    onDismiss();
  };

  return (
    <div className="fixed bottom-20 left-1/2 z-[120] w-[min(92vw,420px)] -translate-x-1/2 rounded-xl border border-border bg-card px-4 py-3 shadow-popover">
      <p className="text-sm text-foreground">
        {t('sessions.learnRule.prompt', { host, session: sessionName })}
      </p>
      <div className="mt-3 flex justify-end gap-2">
        <button
          type="button"
          className="rounded-md px-3 py-1.5 text-xs text-muted-foreground hover:bg-muted"
          onClick={snooze}
        >
          {t('sessions.learnRule.notNow')}
        </button>
        <button
          type="button"
          className="rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground"
          onClick={add}
        >
          {t('sessions.learnRule.add')}
        </button>
      </div>
    </div>
  );
}
